"use client";
import { ITeamType } from "@gettactic/api";
import { api } from "@/lib/api/api";
import { useTeams as useBaseTeams } from "@gettactic/hooks";

type Params = {
  type: ITeamType | "no-fetch";
  hidden?: boolean;
};

export function useTeams(params: Params) {
  // Directly provide the API parameter to avoid type issues
  return useBaseTeams({ ...params, api });
}
